module.exports = __webpack_public_path__ + "696edff06582b524ec084fe93c51c09e.png";